const {
  getRecordingTimelineDownloadInfoV2
} = require('cloud-utils/helpers/recording-stream-helpers')
const RecordingStreamHelperError = require('cloud-utils/errors/recording-stream-helper-error')

angular
  .module('surfsightApp.controllers')
  .controller('RecordingTimelineDownloadController', [
    '$rootScope',
    '$scope',
    '$timeout',
    '$interval',
    '$http',
    '$filter',
    '$translate',
    '$q',
    '$mdToast',
    '$mdDialog',
    '$localStorage',
    'dataFromCaller',
    function (
      $rootScope,
      $scope,
      $timeout,
      $interval,
      $http,
      $filter,
      $translate,
      $q,
      $mdToast,
      $mdDialog,
      $localStorage,
      dataFromCaller
    ) {
      const { getActualRecordingStartTime } = dataFromCaller
      $scope.recordingData = { ...dataFromCaller.recordingData }
      const { serialNumber } = $scope.recordingData
      let { streamId } = $scope.recordingData
      $scope.cameraId = streamId
      $scope.edge = { ...dataFromCaller.edge }
      let mediaToken = $scope.recordingData.mediaToken
      const parsedRecordingTime = moment
        .utc($scope.recordingData.recordingStartTime * 1000)
        .add($scope.recordingData.timezoneOffset, 'minutes')
      $scope.getCameraNameByStreamId = (edge, streamId) =>
        window.getCameraNameByStreamId($filter('translate'), edge, streamId)
      $scope.recordingData.display = {
        dateText: parsedRecordingTime.format('LL'),
        timeText: parsedRecordingTime.format('LT'),
        timezone: window.TimezonesList.find(
          tz => tz.offset === $scope.recordingData.timezoneOffset
        ),
        deviceName: $scope.recordingData.edge.name,
        cameraName: `${$scope.getCameraNameByStreamId(
          $scope.recordingData.edge,
          streamId
        )}`
      }
      const availableBeforeAfterSeconds = [0, 5, 10, 20, 30, 45, 60, 90, 120]
      $scope.availableBeforeAfterSeconds = [...availableBeforeAfterSeconds]
      $scope.recordingDownloadConfig = {
        selectedStartTime: parsedRecordingTime.clone(),
        recordingStreamQuality: $rootScope.recordingStreamQualities.find(
          q => q.value === $scope.recordingData.recordingStreamQuality.value
        ),
        secondsBeforeEvent: 5,
        secondsAfterEvent: 5,
        recordingStartTime: 0
      }
      $scope.recordingDownloadConfigState = {
        maxSecondsBeforeEvent: 0,
        maxSecondsAfterEvent: 0,
        hasRecording: false,
        downloadSrc: false
      }
      $scope.cameraChange = () => {
        streamId = $scope.cameraId
        $scope.recordingDownloadConfigState.downloadSrc = false
      }
      $scope.selectedStartTimeChanged = () => {
        const selectedTime = moment
          .utc(
            parsedRecordingTime
              .clone()
              .format(
                `YYYY-MM-DDT[${$scope.recordingDownloadConfig.selectedStartTime.format(
                  'HH:mm:ss'
                )}]`
              )
          )
          .add(-$scope.recordingData.timezoneOffset, 'minutes')
          .unix()
        const {
          recordingStartTime,
          timelineInterval
        } = getActualRecordingStartTime(streamId, selectedTime)
        const hasRecording = !!recordingStartTime
        const maxSecondsBeforeEvent = hasRecording
          ? recordingStartTime - timelineInterval.start_time
          : 0
        const maxSecondsAfterEvent = hasRecording
          ? timelineInterval.end_time - recordingStartTime
          : 0
        Object.assign($scope.recordingDownloadConfigState, {
          maxSecondsBeforeEvent,
          maxSecondsAfterEvent,
          hasRecording,
          downloadSrc: false
        })
        const sortedAvailableBeforeAfterSeconds = [
          ...availableBeforeAfterSeconds
        ].sort((a, b) => b - a)
        const secondsBeforeEvent = sortedAvailableBeforeAfterSeconds.find(
          s => s <= maxSecondsBeforeEvent
        )
        const secondsAfterEvent = sortedAvailableBeforeAfterSeconds.find(
          s => s <= maxSecondsAfterEvent
        )
        Object.assign($scope.recordingDownloadConfig, {
          secondsBeforeEvent: $scope.recordingDownloadConfig.secondsBeforeEvent
            ? Math.min(
                $scope.recordingDownloadConfig.secondsBeforeEvent,
                secondsBeforeEvent
              )
            : secondsBeforeEvent,
          secondsAfterEvent: $scope.recordingDownloadConfig.secondsAfterEvent
            ? Math.min(
                $scope.recordingDownloadConfig.secondsAfterEvent,
                secondsAfterEvent
              )
            : secondsAfterEvent,
          recordingStartTime
        })
      }
      $scope.selectedStartTimeChanged()
      $scope.beforeAfterSecondsChanged = () => {
        $scope.recordingDownloadConfigState.hasRecording =
          $scope.recordingDownloadConfig.secondsBeforeEvent <=
            $scope.recordingDownloadConfigState.maxSecondsBeforeEvent &&
          $scope.recordingDownloadConfig.secondsAfterEvent <=
            $scope.recordingDownloadConfigState.maxSecondsAfterEvent &&
          !!(
            $scope.recordingDownloadConfig.secondsBeforeEvent ||
            $scope.recordingDownloadConfig.secondsAfterEvent
          )
        $scope.recordingDownloadConfigState.downloadSrc = false
      }
      $scope.downloadQualityChanged = () => {
        $scope.recordingDownloadConfigState.downloadSrc = false
      }
      $scope.downloadRecordingTimelineStatus = {
        inProgress: false
      }
      let requestCompleted = false
      let downloadRecordingAbortController
      $scope.prepareRecordingTimelineDownload = async () => {
        if (
          downloadRecordingAbortController &&
          !downloadRecordingAbortController.aborted
        ) {
          downloadRecordingAbortController.abort()
        }
        downloadRecordingAbortController = new window.AbortController()
        try {
          const url = `${V2_BASEURL}/devices/${serialNumber}/connect-media`

          const { recordingStartTime } = $scope.recordingDownloadConfig
          $scope.downloadRecordingTimelineStatus.inProgress = true
          const startTime =
            recordingStartTime -
            $scope.recordingDownloadConfig.secondsBeforeEvent
          const duration =
            $scope.recordingDownloadConfig.secondsBeforeEvent +
            $scope.recordingDownloadConfig.secondsAfterEvent
          const quality =
            $scope.recordingDownloadConfig.recordingStreamQuality.value
          const { downloadSrc } = await getRecordingTimelineDownloadInfoV2(
            { serialNumber, streamId, startTime, duration, quality },
            {
              getMediaToken: () => mediaToken,
              getBaseUrls: () => ({ url })
            },
            downloadRecordingAbortController,
            {
              'X-Request-Origin': 'White Label Portal',
              'Content-Type': 'application/json',
              Authorization: `Bearer ${$localStorage.userToken}`
            }
          )
          Object.assign($scope.recordingDownloadConfigState, {
            downloadSrc
          })
        } catch (error) {
          console.log(error)
          if (requestCompleted) return
          if (error instanceof RecordingStreamHelperError) {
            return showMessageToast(error.message)
          }
          return showMessageToast('Unable to donwload.')
        } finally {
          $scope.downloadRecordingTimelineStatus.inProgress = false
          $scope.$apply()
        }
      }
      $scope.cancel = () => {
        $mdDialog.cancel()
      }
      const showMessageToast = message => {
        const toast = $mdToast
          .simple()
          .textContent(message)
          .action($translate('ok'))
          .actionKey('F1')
          .position('top right')
          .hideDelay(5000)
          .parent('#recording-timeline-download-container')
        $mdToast
          .show(toast)
          .then(() => {})
          .catch(() => {})
      }
      // TODO: migrate to v2 - stop renewed media token via /generate_authtoken v1. Invoke again /connect-media v2 after 30 minutes
      // TODO: more: https://documentation.s3.us-east-2.amazonaws.com/v2/index.html#operation/postDeviceConnectMedia
      $scope.$on('updateMediaToken', (e, data) => {
        mediaToken = data.mediaToken // update media token
      })
      $scope.$on('$destroy', () => {
        requestCompleted = true
        downloadRecordingAbortController &&
          downloadRecordingAbortController.abort()
      })
    }
  ])
